import React, { useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import BreadCrumbComponent from '@components/obsolete/BreadCrumbComponent/BreadCrumbComponent.tsx';
import COHeadline from '@components/framework/headlines/COHeadline.tsx';
import Tabs, { TabProps } from '@components/ringil3/RingilTabs/Tabs.tsx';
import SvgBuilding from '@icons/building.svg?react';
import SvgComponent from '@icons/component-inverted.svg?react';
import SvgCarrier from '@icons/truck.svg?react';
import AllPartners from '@app/pages/settings/AllPartners.tsx';
import PartnerCodes from '@app/pages/settings/PartnerCodes.tsx';
import AllCarriers from '@app/pages/settings/AllCarriers.tsx';

interface ComponentProps {
}

const Partners: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();
  const [activeTab, setActiveTab] = useState(0);

  const tabsConfig: TabProps[] = [
    {
      label: tr(`Partners.partnersTitle`, `Partner companies`),
      active: activeTab === 0,
      icon: <SvgBuilding />,
    },
    {
      label: tr(`Partners.codesTitle`, `Connection codes`),
      active: activeTab === 1,
      icon: <SvgComponent />,
    },
    {
      label: tr(`Partners.carriersTitle`, `Carriers`),
      active: activeTab === 2,
      icon: <SvgCarrier />,
    },
  ];

  return (
    <>
      <div className={'flex flex-col gap-4'}>
        <BreadCrumbComponent items={[{ label: tr(`Partners.breadCrumb`, `Partners`) }]} />
        <COHeadline title={tr(`Partners.pageTitle`, `Partners`)} variant={'h1'} />

        <Tabs
          tabs={tabsConfig}
          onTabChange={setActiveTab}
          replaceUrl
        />

        {activeTab === 0 && <AllPartners />}
        {activeTab === 1 && <PartnerCodes />}
        {activeTab === 2 && <AllCarriers />}
      </div>
    </>
  );
};

export default Partners;